/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ChangeHistory,
    ChangeHistoryFromJSON,
    ChangeHistoryToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
} from '../models';

export interface EntitiesRequest {
    project_id: number;
    flag_id: number;
}

/**
 * no description
 */
export class ChangesApi extends runtime.BaseAPI {

    /**
     * Get entities associated for a specific Flag in a Project  You can use query parameters to filter/sort the response. 
     * Get Change History
     */
    async entitiesRaw(requestParameters: EntitiesRequest): Promise<runtime.ApiResponse<ChangeHistory>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling entities.');
        }

        if (requestParameters.flag_id === null || requestParameters.flag_id === undefined) {
            throw new runtime.RequiredError('flag_id','Required parameter requestParameters.flag_id was null or undefined when calling entities.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_id}/entities`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_id"}}`, encodeURIComponent(String(requestParameters.flag_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeHistoryFromJSON(jsonValue));
    }

    /**
     * Get entities associated for a specific Flag in a Project  You can use query parameters to filter/sort the response. 
     * Get Change History
     */
    async entities(requestParameters: EntitiesRequest): Promise<ChangeHistory> {
        const response = await this.entitiesRaw(requestParameters);
        return await response.value();
    }

}
